<template>
  <div>
    <v-toolbar class="elevation-1">
      <h4>Report - {{ plural(contactMode) }}</h4>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-container grid-list-xl fluid>
      <report-header
        contact="Contractor"
        @refreshFilter="fetchAttendaceDetails"
        @print="printReport(arguments[0])"
      />

      <print-view
        :items="items"
        :contactMode="contactMode"
        :printMode="false"
      ></print-view>
    </v-container>
  </div>
</template>

<script>
import ReportView from "./ReportView";
export default {
  extends: ReportView,
  data() {
    return {
      contactMode: "Contractor"
    };
  },
  methods: {}
};
</script>

<style scoped>
.justifybetween {
  display: flex;
  justify-content: space-between;
}
.header {
  text-align: center;
}
.report-info {
  display: flex;
  justify-content: space-between;
}
</style>
